export default __webpack_public_path__ + "static/media/section1-bg4.d7d6ec5b.svg";